import { Component, OnInit } from '@angular/core';
import {AuthService} from "../../services/auth.service";
import {User} from "../../models/user.model";
import {UserService} from "../../services/user.service";
import { Role } from '../../models/session.model';
import { environment } from 'src/environments/environment';

@Component({
  selector: 'kis-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {

  loggedIn: boolean;

  user: User;

  canSeeConfig: boolean;

  canSeeReport: boolean;
  
  appVersion: string;

  constructor(public authService: AuthService,
              private userService: UserService) {
    this.loggedIn = authService.loggedIn;
    this.user = userService.user;
    this.canSeeConfig = authService.role == (Role.JujoAdmin || Role.CustomerAdmin);
    this.canSeeReport = authService.role == Role.Reviewer;

    this.appVersion = environment.appVersion;
  }

  ngOnInit(): void {
  }

}
